'use client'

import { useEffect } from 'react'

import { usePathname } from 'next/navigation'

function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' }) // или 'smooth'
  }, [pathname])

  return null
}

export default ScrollToTop
